// extracted by mini-css-extract-plugin
export var typingIndicator = "_no-0";